"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./util/helpers");
var getHost = function (hostOverride) {
    switch (hostOverride) {
        case 'PO-PROD':
            return 'https://wrangler.prod.productoptions.vpsvc.com/api';
        case 'PO-SAND':
            return 'https://wrangler.sandbox.productoptions.vpsvc.com/api';
        case 'LEGACY':
        default:
            return 'https://wrangler.prod.merch.vpsvc.com/api';
    }
};
// We'll keep a small cache of responses so that the customer can click back and forth very quickly
var CACHE = {};
var MAX_CACHE_SIZE = 50;
var WranglerDataSource = /** @class */ (function () {
    function WranglerDataSource() {
    }
    WranglerDataSource.getWranglerData = function (request, hostOverride) {
        return __awaiter(this, void 0, void 0, function () {
            var merchant, culture, productKey, productVersion, merchandisingExperience, merchAttr, selectedAttributes, initialSelectedAttributes, selectedQuantity, requestor, documentUrl, includeVat, priceStyle, couponCode, pricingContextString, testUserId, imageTransformations, iconTransformations, deselectCompletedOptions, excludeInitialSelectedAttributes, requestParams, cacheKey;
            var _this = this;
            return __generator(this, function (_a) {
                merchant = request.merchant, culture = request.culture, productKey = request.productKey, productVersion = request.productVersion, merchandisingExperience = request.merchandisingExperience, merchAttr = request.merchAttr, selectedAttributes = request.selectedAttributes, initialSelectedAttributes = request.initialSelectedAttributes, selectedQuantity = request.selectedQuantity, requestor = request.requestor, documentUrl = request.documentUrl, includeVat = request.includeVat, priceStyle = request.priceStyle, couponCode = request.couponCode, pricingContextString = request.pricingContextString, testUserId = request.testUserId, imageTransformations = request.imageTransformations, iconTransformations = request.iconTransformations, deselectCompletedOptions = request.deselectCompletedOptions, excludeInitialSelectedAttributes = request.excludeInitialSelectedAttributes;
                requestParams = {
                    merchandisingExperience: merchandisingExperience,
                    merchAttr: merchAttr,
                    responseComponents: ["standardConfigurator"],
                    selectedAttributes: selectedAttributes,
                    selectedQuantity: selectedQuantity,
                    requestor: requestor,
                    initialSelectedAttributes: initialSelectedAttributes,
                    documentUrl: documentUrl,
                    includeVat: includeVat,
                    priceStyle: priceStyle,
                    couponCode: couponCode,
                    pricingContextString: pricingContextString,
                    optimizelyUserId: testUserId,
                    imageTransformations: helpers_1.cloudinaryParamsToString(imageTransformations),
                    iconTransformations: helpers_1.cloudinaryParamsToString(iconTransformations),
                    deselectCompletedOptions: deselectCompletedOptions,
                    excludeInitialSelectedAttributes: excludeInitialSelectedAttributes,
                };
                if (!merchandisingExperience && !merchAttr) {
                    return [2 /*return*/, {
                            data: undefined,
                            exceptionMessages: ["Either 'merchandisingExperience' or 'merchAttr' must be provided."]
                        }];
                }
                cacheKey = helpers_1.serializeToUseEffectString(request);
                if (CACHE[cacheKey] === undefined) {
                    this.addToCache(cacheKey, new Promise(function (resolve, reject) {
                        var url = getHost(hostOverride) + "/v1/" + merchant + "/" + culture + "/configuratorData/" + productKey + "/" + productVersion + "?" + helpers_1.serializeParams(requestParams);
                        fetch(url)
                            .then(function (response) { return response.json(); })
                            .then(function (response) { return resolve({ data: _this.remapResponse(response, culture), exceptionMessages: response.exceptionMessages }); })
                            .catch(function (err) { return reject({ data: undefined, exceptionMessages: ["error call to wrangler get endpoint failed: " + (err.message ? err.message : "")] }); });
                    }));
                }
                return [2 /*return*/, CACHE[cacheKey]];
            });
        });
    };
    WranglerDataSource.realizeDocument = function (authToken, document) {
        return __awaiter(this, void 0, void 0, function () {
            var changesPending, resolutionUrl, response, err_1, udsResponse, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        changesPending = document.changesPending;
                        if (!changesPending) {
                            return [2 /*return*/, undefined];
                        }
                        if (!authToken) {
                            throw new Error("AuthToken required to realize and save document");
                        }
                        resolutionUrl = document.url;
                        if (!resolutionUrl) {
                            throw new Error("Document resolution url required to realize and save document");
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(resolutionUrl, {
                                headers: {
                                    authorization: "Bearer " + authToken
                                }
                            })
                                .then(function (response) { return response.json(); })];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        throw new Error("Document resolution failed: url: " + resolutionUrl + "; exception: " + (err_1.message ? err_1.message : err_1.stack));
                    case 4:
                        udsResponse = undefined;
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.postDocumentToUDS(response, authToken)];
                    case 6:
                        udsResponse = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        err_2 = _a.sent();
                        throw new Error("error posting document to UDS: " + JSON.stringify(udsResponse) + "; exception: " + (err_2.message ? err_2.message : err_2.stack));
                    case 8: return [2 /*return*/, udsResponse === null || udsResponse === void 0 ? void 0 : udsResponse._links];
                }
            });
        });
    };
    WranglerDataSource.addToCache = function (key, value) {
        // The client-side cache exists so that as the customer clicks back and forth, they will
        // go back instantly to the previous response.
        //
        // We will prevent this cache from getting large.
        var currentKeys = Object.keys(CACHE);
        if (currentKeys.length > MAX_CACHE_SIZE) {
            delete CACHE[currentKeys[0]];
        }
        CACHE[key] = value;
    };
    WranglerDataSource.postDocumentToUDS = function (document, authToken) {
        return __awaiter(this, void 0, void 0, function () {
            var udsBaseUrl, hoursToCache, url, responseData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        udsBaseUrl = "https://uds.documents.cimpress.io";
                        hoursToCache = '1';
                        url = udsBaseUrl + "/v3/documents?cacheForHours=" + hoursToCache;
                        return [4 /*yield*/, fetch(url, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    authorization: "Bearer " + authToken,
                                },
                                body: JSON.stringify(document)
                            })
                                .then(function (response) { return response.json(); })];
                    case 1:
                        responseData = _a.sent();
                        return [2 /*return*/, responseData];
                }
            });
        });
    };
    // Wrangler returns its data, but WranglerDataSource tweaks that data:
    // * Change quantities to be numbers instead of strings
    // * Add translations to badges.
    WranglerDataSource.remapResponse = function (wranglerData, culture) {
        var _a, _b, _c, _d;
        // This is written so that if Wrangler starts returning numbers, we don't have to change anything.
        // If the value can't be parsed, then we'll return undefined.
        function safeParseInt(value) {
            switch (typeof (value)) {
                case "string":
                    var result = parseInt(value);
                    return isNaN(result) ? undefined : result;
                case "number":
                    return value;
                default:
                    return undefined;
            }
        }
        var standardConfigurator = wranglerData.standardConfigurator;
        return __assign(__assign({}, standardConfigurator), { attributes: standardConfigurator.attributes.map(function (attr) { return (__assign(__assign({}, attr), { options: attr.options.map(function (opt) { return (__assign(__assign({}, opt), { violations: opt.violations, badges: opt.enhancedBadges.map(function (enhancedBadge) {
                        return {
                            id: enhancedBadge.key,
                            text: enhancedBadge.text
                        };
                    }) })); }) })); }), quantities: __assign(__assign({}, standardConfigurator.quantities), { selected: safeParseInt((_a = standardConfigurator.quantities) === null || _a === void 0 ? void 0 : _a.selected), quantities: (_c = (_b = standardConfigurator.quantities) === null || _b === void 0 ? void 0 : _b.quantities) === null || _c === void 0 ? void 0 : _c.map(function (q) { return (__assign(__assign({}, q), { quantity: safeParseInt(q.quantity), badges: q.enhancedBadges.map(function (enhancedBadge) {
                        return {
                            id: enhancedBadge.key,
                            text: enhancedBadge.text
                        };
                    }) })); }) }), selections: __assign(__assign({}, standardConfigurator.selections), { quantity: safeParseInt((_d = standardConfigurator.selections) === null || _d === void 0 ? void 0 : _d.quantity) }) });
    };
    return WranglerDataSource;
}());
exports.default = WranglerDataSource;
//# sourceMappingURL=WranglerDataSource.js.map